import logger from '../utils/logger';
/**
 * Safe property access utilities to prevent runtime errors
 */

// Safe number formatting
export const safeToLocaleString = (value, fallback = '0') => {
  if (value == null || value === undefined || isNaN(value)) {
    return fallback;
  }
  return Number(value).toLocaleString();
};

// Safe string operations
export const safeToLowerCase = (value, fallback = '') => {
  if (value == null || value === undefined) {
    return fallback;
  }
  return String(value).toLowerCase();
};

// Safe property access with fallback
export const safeGet = (obj, path, fallback = null) => {
  try {
    const keys = path.split('.');
    let current = obj;
    
    for (const key of keys) {
      if (current == null || current === undefined) {
        return fallback;
      }
      current = current[key];
    }
    
    return current !== undefined ? current : fallback;
  } catch (error) {
    logger.warn(`Safe access failed for path "${path}":`, error);
    return fallback;
  }
};

// Safe array operations
export const safeMap = (array, mapFn, fallback = []) => {
  if (!Array.isArray(array)) {
    return fallback;
  }
  
  try {
    return array.map(mapFn);
  } catch (error) {
    logger.warn('Safe map operation failed:', error);
    return fallback;
  }
};

// Safe industry slug generation
export const createIndustrySlug = (industryName) => {
  if (!industryName) {
    return 'food-beverage'; // Default fallback
  }
  
  const safeName = String(industryName);
  return safeName.toLowerCase().replace(' & ', '-').replace(/\s+/g, '-');
};

// Safe data validation
export const validateIndustryData = (industry) => {
  return {
    name: safeGet(industry, 'name', 'Unknown Industry'),
    total_facilities: safeGet(industry, 'total_facilities', 0),
    regions: safeGet(industry, 'regions', ['naics']),
    naics_codes: safeGet(industry, 'naics_codes', []),
    anzsic_codes: safeGet(industry, 'anzsic_codes', [])
  };
};

// Safe assessment data validation
export const validateAssessmentData = (assessment) => {
  return {
    id: safeGet(assessment, 'id', ''),
    facility_name: safeGet(assessment, 'facility_name', 'Unknown Facility'),
    industry_name: safeGet(assessment, 'industry_name', 'Unknown Industry'),
    estimated_savings: safeGet(assessment, 'estimated_savings', 0),
    assessment_type: safeGet(assessment, 'assessment_type', 'basic'),
    completion_date: safeGet(assessment, 'completion_date', new Date().toISOString()),
    progress: safeGet(assessment, 'progress', 0)
  };
};

export default {
  safeToLocaleString,
  safeToLowerCase,
  safeGet,
  safeMap,
  createIndustrySlug,
  validateIndustryData,
  validateAssessmentData
};